import { render } from "./PawIcon.vue?vue&type=template&id=88dd9ea8"
import script from "./PawIcon.vue?vue&type=script&lang=js"
export * from "./PawIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__